import { render, staticRenderFns } from "./CompletionEfficiency.vue?vue&type=template&id=2b7349fe&scoped=true&"
import script from "./CompletionEfficiency.vue?vue&type=script&lang=js&"
export * from "./CompletionEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./CompletionEfficiency.vue?vue&type=style&index=0&id=2b7349fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7349fe",
  null
  
)

export default component.exports